import { createSlice } from "@reduxjs/toolkit";
import { getAllObjectives } from "../actions/objectives.actions";

const initialState = {
  objectives: [] as any,
  loading: false,
  error: null as unknown | null,
};
export const objectiveSlice = createSlice({
  name: "objectives",
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAllObjectives.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAllObjectives.fulfilled, (state, action) => {
        state.objectives = action.payload;
        state.loading = false;
      })
      .addCase(getAllObjectives.rejected, (state, action) => {
        state.objectives = [];
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default objectiveSlice.reducer;
